import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
// import { useCurrentOrganization } from '@/modules/core/hooks';
// import useServiceCategoriesQuery from '@/modules/employer/queries/useServiceCategories.query';
import { OrganizationTypes } from '@/common/constants';
import { API_URL } from '@/dtos';

import { CopayGroupPayload, CopayPayload } from '../CopayAdjudication.constant';

export const QUERY_KEY_COPAY_BY_ID = 'GET_COPAY_GROUPS_BY_ID';

interface CopayResponsePayload {
  id: number;
  category_type: string;
  amount: number;
}
export interface CopayGroupResponsePayload {
  id: number;
  name: string;
  organization_type: OrganizationTypes;
  copays: CopayResponsePayload[];
  valid_from: string | null;
  valid_to: string | null;
}

const useCopayGroupByIdQuery = (copayId?: string) => {
  const { isLoading, data } = useQuery(
    [QUERY_KEY_COPAY_BY_ID, copayId],
    () =>
      api.get(API_URL.COPAY_GROUPS_BY_ID(copayId || ''), {
        params: {
          // search_value: searchString,
          // organization_id: id,
          // organization_path: path,
          // name: params?.searchString,
          // copay_status: params?.statuses ? params?.statuses.join(',') : undefined, // active, expired
        },
      }),
    {
      enabled: Boolean(copayId),
    }
  );

  const formattedData = useMemo((): CopayGroupPayload | null => {
    const item = data?.data;
    if (!item) {
      return null;
    }
    return {
      id: `${item.id}`,
      name: item.name || '',
      organizationType: item.organization_type as unknown as OrganizationTypes,
      copays:
        item?.copays?.map(
          (copay): CopayPayload => ({
            id: `${copay.id}`,
            category: copay.category_type || '',
            amount: `${copay.amount}`,
          })
        ) || [],
      validFrom: item.valid_from as string,
      validTo: item.valid_to as string,
    };
  }, [data]);

  return {
    data: formattedData,
    isLoading,
  };
};

export default useCopayGroupByIdQuery;
